import React, { useState } from 'react';
import moment from 'moment/moment';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';
import { RealizedGainLossDTO } from '../../../../../../../../api/useRealizedGainLossQuery';
import { formatCurrency, formatNumber } from '../../../../../../../../../CommonUtils/formatNumber';
import { HtmlTable } from '../../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Box } from '../../../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../../../CommonComponents/OPL/Button/Button';
import { Column, DEFAULT_COLUMNS, TAX_LOT_COLUMNS } from '../../InvestmentTable.meta';

interface Props {
  investment: RealizedGainLossDTO;
}
export const DesktopInvestmentTable = ({ investment }: Props) => {
  const [isTaxLotVisible, setIsTaxLotVisible] = useState(false);

  const columns = isTaxLotVisible ? TAX_LOT_COLUMNS : DEFAULT_COLUMNS;

  return (
    <HtmlTable columnSpacing="small">
      <table>
        <caption>
          <Box display="flex" justifyContent="space-between">
            <Text fontSize="h6" fontWeight={600}>
              {investment.name}
            </Text>

            <Button variant="link" onClick={() => setIsTaxLotVisible(state => !state)}>
              {isTaxLotVisible ? 'Hide Tax Lots' : 'Show Tax Lots'}
            </Button>
          </Box>
        </caption>

        <thead>
          <tr>
            {columns.map(({ key, name, align }) => (
              <th key={key}>
                <Text variant="tableHeader" textAlign={align}>
                  {name}
                </Text>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {isTaxLotVisible ? (
            investment.taxLots.map(taxLot => {
              return (
                <tr>
                  {columns.map(column => {
                    const value = taxLot[column.key] as number | string;

                    return <TableCell key={column.key} value={value} column={column} />;
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              {columns.map(column => {
                const value = investment[column.key] as number | string;

                return <TableCell key={column.key} value={value} column={column} />;
              })}
            </tr>
          )}
        </tbody>
      </table>
    </HtmlTable>
  );
};

interface TableCellProps {
  value: number | string;
  column: Column;
}

const TableCell = ({ column: { align, type }, value }: TableCellProps) => {
  return (
    <td>
      <Text
        textAlign={align}
        variant="tabular"
        color={
          type === 'currency' && typeof value === 'number' && value < 0
            ? 'error.500'
            : 'neutral.700'
        }
      >
        {type === 'number' && typeof value === 'number' && (
          <>{formatNumber(value, { decimalPlaces: 2 })}</>
        )}
        {type === 'currency' && typeof value === 'number' && (
          <>{formatCurrency(value, { decimalPlaces: 2 })}</>
        )}
        {type === 'date' && <>{value ? moment(value).format('M/D/YYYY') : ''}</>}
      </Text>
    </td>
  );
};
